module.exports = __webpack_public_path__ + "./img/60cadeaef5c457abdcc611cb315eefd5.png";